import { ReactNode } from 'react'

import { Box } from '@percent/lemonade'
import classes from './BadgesContainer.module.scss'

interface BadgesContainerProps {
  children: ReactNode
  testId?: string
}

export function BadgesContainer({ children, testId }: BadgesContainerProps) {
  return (
    <Box className={classes.badgesContainer} data-testid={testId}>
      {children}
    </Box>
  )
}
